import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c057694"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sign-up" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create your free Openbay Account.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "To receive estimates, you'll first need to create an account.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_SignUpForm = _resolveComponent("SignUpForm")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives(_createVNode(_component_LoadingSpinner, {
      class: "mt-5",
      centered: "",
      relative: ""
    }, null, 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_SignUpForm, {
        onAuthSuccess: _ctx.authSuccess,
        onAuthFail: _ctx.authFail
      }, null, 8, ["onAuthSuccess", "onAuthFail"])
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ]))
}